import React from "react";
import { Stack, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";

import dementia from "src/shared/assets/dementia.png";
import parkinson from "src/shared/assets/parkinson.png";

import { questions } from "../model/constants";

import { ProgressSection } from "./ProgressSection/ProgressSection";
import { QuestionAccordion } from "./QuestionAccordion/QuestionAccordion";

export const SicheroFooter: React.FC = () => {
  return (
    <>
      <Typography
        variant="h4"
        color={blueGrey[600]}
        letterSpacing={4}
        textTransform="uppercase"
        whiteSpace="pre-wrap"
        textAlign="center"
      >
        Work in Progress {"\n"}Pre-detection of diseases
      </Typography>

      <ProgressSection
        direction="row-reverse"
        title="Dementia"
        description="SICHERO's sophisticated algorithms are designed to recognize common
            objects such as keys, umbrellas, bottles, and TV remote controls,
            among others. It features a dynamic 'forgetting score' that tracks
            the frequency of forgotten items. If this score exceeds a certain
            limit, indicating a pattern of forgetfulness, SICHERO advises family
            members to suggest that their loved one should receive a
            professional health assessment."
        image={dementia}
      />

      <ProgressSection
        direction="row"
        title="Parkinson"
        description="SICHERO's advanced algorithms enable the detection of patient
            movements with granular precision, allowing for the identification
            of irregularities in skeletal motion. These insights can
            subsequently aid in recognizing patterns indicative of the
            progression of Parkinson's disease in patients."
        image={parkinson}
      />

      <Typography
        variant="h4"
        color={blueGrey[600]}
        letterSpacing={4}
        textTransform="uppercase"
        whiteSpace="pre-wrap"
        textAlign="center"
      >
        Frequently Asked Questions
      </Typography>

      <Stack width={1} maxWidth="lg" direction="column" spacing={0}>
        {questions.map((questionItem, index) => (
          <QuestionAccordion
            key={questionItem.question}
            title={questionItem.question}
            description={questionItem.answer}
            defaultExpanded={!index}
          />
        ))}
      </Stack>
    </>
  );
};
